// extracted by mini-css-extract-plugin
export default {"button":"SPButton_button__dPzD9","plain":"SPButton_plain__Fboqj","primary":"SPButton_primary__JSG1P","secondary":"SPButton_secondary__amfa5","circle":"SPButton_circle__hcqit"};